/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'

// Hooks
import { BrowserProvider, JsonRpcSigner } from 'ethers'
import { useAppKitProvider } from '@reown/appkit/react'

// Components
import { Button } from 'views/components'

function EthereumProvider(props) {
  const { messageToSign, setSignature, address, isLoading } = props
  const { walletProvider } = useAppKitProvider('eip155') // Namespace for EVM chains

  const handleSignEth = async () => {
    try {
      // Create an Ethers.js provider and signer from the AppKit walletProvider
      const provider = new BrowserProvider(walletProvider)
      const signer = new JsonRpcSigner(provider, address)
      const signature = await signer.signMessage(messageToSign)

      if (setSignature) {
        setSignature(signature)
      }
    } catch (error) {
      console.error('Error signing ETH message:', error)
    }
  }

  return (
    <Button fullWidth type="button" onClick={handleSignEth} disabled={isLoading}>
      {isLoading ? 'Loading...' : 'Sign ETH Message'}
    </Button>
  )
}
// Default Props
EthereumProvider.defaultProps = {
  addressVerificationDetails: {},
}

// Proptypes Validation
EthereumProvider.propTypes = {
  addressVerificationDetails: PropTypes.shape({
    symbol: PropTypes.string,
    address: PropTypes.string,
    chain: PropTypes.string,
    created: PropTypes.string,
  }),
}

export default EthereumProvider
